import ProgressBar from './ProgressBar';

function SeriesHover({
  series,
  onClose,
  hydrateProgress,
  isHydrated,
  onView,
}) {
  const title =
    series.label ||
    series.seriesDescription ||
    'Series';

  const previewMax = 'min(360px, 58vh)';
  const previewMin = '96px';

  return (
    <div
      className="profile-hover-container"
      style={{
        flexDirection: 'column',
        alignItems: 'stretch',
        width: 'min(400px, 96vw)',
        maxWidth: '100%',
        minHeight: 0
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'flex-start', flexShrink: 0 }}>
        <span className="profile-hover-name">{title}</span>
        <button
          type="button"
          className="profile-hover-close-btn"
          style={{ boxSizing: 'inherit' }}
          aria-label="Close preview"
          onClick={onClose}
        >
          ×
        </button>
      </div>
      <div
        style={{
          marginTop: '0.75rem',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          flex: '0 1 auto',
          minHeight: 0
        }}
      >
        <div
          role={isHydrated && onView ? 'button' : undefined}
          tabIndex={isHydrated && onView ? 0 : undefined}
          aria-label={isHydrated && onView ? 'View series' : undefined}
          onClick={() => {
            if (!isHydrated || !onView) return;
            onClose?.();
            onView();
          }}
          onKeyDown={(e) => {
            if (!isHydrated || !onView) return;
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClose?.();
              onView();
            }
          }}
          style={{
            width: '100%',
            height: previewMax,
            flex: '0 1 auto',
            minHeight: previewMin,
            background: '#000',
            borderRadius: '4px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: isHydrated && onView ? 'pointer' : 'default'
          }}
          onContextMenu={(e) => e.preventDefault()}
        >
          {series.thumbnailUrl ? (
            <img
              src={series.thumbnailUrl}
              alt=""
              draggable={false}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                display: 'block'
              }}
            />
          ) : (
            <div
              style={{
                color: '#777',
                fontSize: '12px',
                padding: '2.5rem 3rem',
                lineHeight: 'normal',
                textAlign: 'center'
              }}
            >
              Loading…
            </div>
          )}
        </div>
      </div>

      <div style={{ marginTop: '0.35rem', textAlign: 'left', flexShrink: 0 }}>
        <ProgressBar
          label={hydrateProgress?.label || 'Loading series'}
          percent={hydrateProgress?.percent ?? 0}
          detail={hydrateProgress?.detail || ''}
          visible={!!hydrateProgress}
        />
      </div>

      <button
        type="button"
        className="continue-button"
        style={{
          marginTop: '0.75rem',
          padding: '0.5rem',
          width: '100%',
          fontWeight: 'bold',
          flexShrink: 0
        }}
        disabled={!isHydrated}
        onClick={() => {
          if (!isHydrated || !onView) return;
          onClose?.();
          onView();
        }}
      >
        View series
      </button>
    </div>
  );
}

export default SeriesHover;
